import { BunnyLoader } from '@app/components/ui/bunny';
import cn from 'classnames';
import Image, { ImageProps } from 'next/image';
import { useState } from 'react';

interface LazyImageProps extends Omit<ImageProps, 'onLoad' | 'placeholder'> {
    /** Size of the bunny shown while the image downloads. */
    loaderSize?: number;
    wrapperClassName?: string;
}

/**
 * Lazy image with a bunny holding the space until it arrives.
 * The wrapper must be positioned and sized by the caller, since `fill` images
 * take their dimensions from it.
 */
export default function LazyImage({ className, wrapperClassName, loaderSize = 34, ...props }: LazyImageProps) {
    const [loaded, setLoaded] = useState(false);

    return (
        <span className={cn('absolute inset-0 block', wrapperClassName)}>
            {!loaded && (
                <span className="absolute inset-0 flex items-center justify-center bg-paper">
                    <BunnyLoader size={loaderSize} />
                </span>
            )}
            {/* `loading` stays lazy: next/image only eager-loads when priority is set. */}
            <Image {...props} onLoad={() => setLoaded(true)} className={cn('transition-opacity duration-500', loaded ? 'opacity-100' : 'opacity-0', className)} />
        </span>
    );
}
